module.exports = __webpack_public_path__ + "img/Tessellate37.eeca8870.jpg";